<template>
  <!-- 截断检测为 true 时才包 tooltip（未截断的单元格 hover 不弹预览），el-tooltip 需直接包裹真实元素 -->
  <el-tooltip v-if="clipped" :content="text" placement="top" effect="dark" :open-delay="200">
    <div ref="box" class="clamp-cell" :style="clampStyle">{{ text }}</div>
  </el-tooltip>
  <div v-else ref="box" class="clamp-cell" :style="clampStyle">{{ text }}</div>
</template>

<script>
// 通用多行截断单元格：内容超过 lines 行（默认 4）时尾部省略号截断，
// 且只有真正被截断的单元格 hover 时才出现 tooltip 预览全部内容；
// 截断判定：渲染后比较 scrollHeight 与 clientHeight（多 2px 容差防亚像素误差）
export default {
  name: "ClampCell",
  props: {
    text: { type: String, default: "" },
    lines: { type: Number, default: 4 },
  },
  data() {
    return { clipped: false };
  },
  computed: {
    clampStyle() {
      return {
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": this.lines,
        overflow: "hidden",
        "word-break": "break-all",
        "line-height": "1.5",
      };
    },
  },
  methods: {
    checkClipped() {
      this.$nextTick(() => {
        const el = this.$refs.box;
        if (!el) return;
        this.clipped = el.scrollHeight > el.clientHeight + 2;
      });
    },
  },
  mounted() {
    this.checkClipped();
  },
  updated() {
    this.checkClipped();
  },
};
</script>

<style scoped>
.clamp-cell {
  text-align: left;
  font-size: 12px;
}
</style>
